import { render } from "./InvitationForm.vue?vue&type=template&id=5dd37c49&scoped=true"
import script from "./InvitationForm.vue?vue&type=script&lang=js"
export * from "./InvitationForm.vue?vue&type=script&lang=js"

import "./InvitationForm.vue?vue&type=style&index=0&id=5dd37c49&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/drop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd37c49"]])

export default __exports__